import { useEffect, useState } from "react";
import { toast } from "sonner";
import platformApi from "@/lib/platformApi";
import { formatApiErrorDetail } from "@/lib/api";
import { ManualReader } from "@/components/manual/ManualReader";

export default function PlatformManualPanel() {
  const [data, setData] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    platformApi.get("/manual").then((r) => setData(r.data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  }, []);

  const download = async () => {
    setDownloading(true);
    try {
      const res = await platformApi.get("/manual/pdf", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "platform-owner-manual.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not generate the PDF — try again");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div data-testid="platform-manual-panel">
      <ManualReader data={data} onDownload={download} downloading={downloading} />
    </div>
  );
}
